import React, { useEffect, useState } from "react";
import OtpInput from "./OtpInput";

const RESEND_SECONDS = 30;

const OtpVerification = ({
  loading = false,
  otp = "",
  onOtpChange = () => {},
  onVerify = () => {},
  onResend = () => {},
  resetKey = 0,
}) => {
  const [countdown, setCountdown] = useState(RESEND_SECONDS);

  useEffect(() => {
    setCountdown(RESEND_SECONDS);
  }, [resetKey]);

  useEffect(() => {
    if (countdown <= 0) return;
    const timer = setInterval(() => {
      setCountdown((c) => c - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [countdown]);

  const formatTime = (total) => {
    const minutes = Math.floor(total / 60);
    const seconds = total % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0",
    )}`;
  };

  const isComplete = otp.length === 6;

  return (
    <div className="animate-in w-full max-w-[400px] rounded-2xl bg-white px-2 py-10 shadow-2xl">
      <div className="mb-2 flex justify-center">
        <img
          src="./logo.png"
          alt="Logo"
          className="h-20 w-20 rounded-2xl object-contain"
        />
      </div>

      <h1 className="text-center text-3xl font-bold text-gray-900">
        Verify OTP
      </h1>
      <p className="mx-auto mt-3 max-w-xs text-center text-sm leading-relaxed text-gray-500">
        We&apos;ve sent a 6-digit verification code to your registered email.
      </p>

      <div className="mt-6 flex w-full justify-center overflow-hidden">
        <div className="flex w-fit flex-col items-center py-4">
          <OtpInput
            value={otp}
            onChange={onOtpChange}
            disabled={loading}
            autoFocus
          />

          <button
            type="button"
            onClick={onVerify}
            disabled={loading || !isComplete}
            aria-label="Verify OTP"
            className="mt-8 flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-blue-600 to-blue-500 text-base font-semibold text-white shadow-lg transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl hover:brightness-110 focus:outline-none focus:ring-4 focus:ring-blue-200 disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:translate-y-0 disabled:hover:shadow-none"
          >
            {loading ? (
              <>
                <span
                  className="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white/40 border-t-white"
                  aria-hidden="true"
                />
                Verifying...
              </>
            ) : (
              "Verify OTP"
            )}
          </button>
        </div>
      </div>

      <div className="mt-4 flex justify-center text-center">
        {countdown > 0 ? (
          <p className="text-sm text-gray-400">
            Resend OTP in{" "}
            <span className="font-semibold tabular-nums text-gray-600">
              {formatTime(countdown)}
            </span>
          </p>
        ) : (
          <button
            type="button"
            onClick={onResend}
            disabled={loading}
            className="text-sm font-medium text-blue-600 transition-colors duration-200 hover:text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-200 disabled:cursor-not-allowed disabled:opacity-60"
          >
            Resend OTP
          </button>
        )}
      </div>
    </div>
  );
};

export default OtpVerification;
